export const isMixedReviewEnabled = () =>
  process.env.REACT_APP_SALUD_V2_MIXED_REVIEW_QA_ENABLED === "true";

export function getReviewQaHttp() {
  // Defer QA dependencies so flag-off legacy views keep their previous loading behavior.
  const { getQaConfiguration, getQaAxiosClient } = require("../formulariosV2/utils/saludV2Client");
  const config = getQaConfiguration();
  if (!isMixedReviewEnabled() || !config.enabled) {
    throw new Error(config.reason || "La revision mixta QA no esta habilitada.");
  }
  let token;
  try { token = JSON.parse(localStorage.getItem("token") || "null")?.idToken; } catch (_) { /* Invalid session. */ }
  if (!token) { const error = new Error("Sesion vencida."); error.status = 401; throw error; }
  const client = getQaAxiosClient(config);
  const headers = { Authorization: `Bearer ${token}`, "x-access-token": token };
  return Object.fromEntries(["get", "patch", "post"].map(method => [method, (url, body, options) =>
    client.request({ method, url, ...(method === "get" ? body : options),
      ...(method !== "get" ? { data: body } : {}), headers })]));
}

const root = "/revision-rapida/salud";
const uuidPath = id => {
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(id)) {
    throw new Error("UUID de atencion invalido.");
  }
  return `${root}/registros/v2/${encodeURIComponent(id)}`;
};
export const revisionV2Api = {
  list: async (id, params) => (await getReviewQaHttp().get(`${root}/convocatorias/${encodeURIComponent(id)}/registros-mixtos`, { params })).data,
  summary: async id => (await getReviewQaHttp().get(`${root}/convocatorias/${encodeURIComponent(id)}/resumen-mixto`)).data,
  get: async id => (await getReviewQaHttp().get(uuidPath(id))).data.data,
  patch: async (id, body) => (await getReviewQaHttp().patch(uuidPath(id), body)).data.data,
  history: async (id, cursor) => (await getReviewQaHttp().get(`${uuidPath(id)}/historial`, { params: { limit: 25, ...(cursor ? { cursor } : {}) } })).data,
};

export const mixedRowKey = (row, index = 0) => row?.resourceType && row?.resourceId !== undefined && row?.resourceId !== null
  ? `${row.resourceType}:${row.resourceId}` : `loading-row-${index}`;
export const MIXED_PROJECTED_FIELDS = new Set(["codigo", "cedula", "nombre", "apellido"]);
export const mixedColumnVisibility = legacy => Object.fromEntries(Object.keys(legacy).map(key =>
  [key, ["codigo", "nombre", "apellido", "source", "status"].includes(key)]));
export const mixedSourceLabel = row => row.resourceType === "V2_CAPTURE"
  ? (row.familia === "NUTRISALUD" ? "NutriSalud V2" : "Anticonceptivos V2")
  : row.source === "V2" ? "Salud Clinica V2" : "LEGACY";
